<template>
    <div>
      <router-view :roleId="roleId"></router-view>
    </div>
</template>

<script>
export default {
  props: ['roleId'],
};
</script>

<style scoped>

</style>
